module.exports = __webpack_public_path__ + "static/media/dodgem(10).7021269a.PNG";